module.exports = "pegasus/assets/gray-large-linkedin.png";